<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">Solicitudes - Revisor</span></li>
      </ol>
    </div>
  </div>
</div>
<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Solicitudes - Revisor</h3>
    </div>

    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Compañía:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="model.idCompania" [disabled]="listaCompanias.length == 1"
                (selectionChange)="companiaChanged()">
                <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                  {{ company.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Sede:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="model.sedes" name="sedes" multiple>
                <mat-option *ngFor="let item of listaSedes; index as i" [value]="item.idSede">{{ item.nombre
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Código solicitud:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Código Solicitud
              </mat-label>
              <input matInput type="text" [(ngModel)]="model.codigo" name="codigo" maxlength="10">
            </mat-form-field>
          </div>

          <label class="col-md-2 control-label">Empresa:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Empresa
              </mat-label>
              <input matInput type="text" placeholder="Empresa" [(ngModel)]="model.contratista" name="contratista"
                maxlength="40">
            </mat-form-field>
          </div>

        </div>

        <div class="form-group">
          <label class="col-md-2 control-label">Estado:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Estado</mat-label>
              <mat-select [(ngModel)]="model.estados" multiple disabled>
                <mat-option *ngFor="let item of listaEstadosSolicitudes" [value]="item.idParametroDetalle">
                  {{item.nombre}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Fecha de Solicitud:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Fecha de registro</mat-label>
              <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Desde" [(ngModel)]="model.fechaInicio">
                <input matEndDate placeholder="Hasta" [(ngModel)]="model.fechaFin">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">


          <label class="col-md-2 control-label">Solicitante:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Solicitante
              </mat-label>
              <input matInput type="text" placeholder="Solicitante" [(ngModel)]="model.solicitante" name="solicitante"
                maxlength="40">
            </mat-form-field>
          </div>

        </div>
      </div>
    </div>
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <div class="col-sm-6 text-left">
            <!-- <a class="btn btn-new" mat-raised-button [routerLink]="['/solicitudes-engie', 'registrar']"><mat-icon>description</mat-icon> Nueva solicitud</a>                            -->
            <!-- [routerLink]="['/solicitudes-engie/registrar']" -->
            <a class="btn btn-celeste" mat-raised-button (click)="export()"><mat-icon>table_chart</mat-icon>
              Exportar</a>
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()"><mat-icon>search</mat-icon> Buscar</a>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table mat-table [dataSource]="listaSolicitudes" class="table table-striped table-vcenter">
          <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef>Código Solicitud</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.codigo }}</td>
          </ng-container>

          <ng-container matColumnDef="compania">
            <th mat-header-cell *matHeaderCellDef>Compañía</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.compania }}</td>
          </ng-container>

          <ng-container matColumnDef="contratista">
            <th mat-header-cell *matHeaderCellDef>Empresa</th>
            <td mat-cell *matCellDef="let element">{{ element.contratista }}</td>
          </ng-container>

          <ng-container matColumnDef="trabajo">
            <th mat-header-cell *matHeaderCellDef>Trabajo</th>
            <td mat-cell *matCellDef="let element">{{ element.trabajo }}</td>
          </ng-container>

          <ng-container matColumnDef="fecha">
            <th mat-header-cell *matHeaderCellDef>Fecha de Solicitud</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.fechaSolicitud | date:'dd/MM/yyyy'}}</td>
          </ng-container>

          <ng-container matColumnDef="sede">
            <th mat-header-cell *matHeaderCellDef>Sede</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.nombreSede }}</td>
          </ng-container>

          <ng-container matColumnDef="solicitante">
            <th mat-header-cell *matHeaderCellDef>Solicitante</th>
            <td mat-cell *matCellDef="let element">{{ element.solicitante }}</td>
          </ng-container>

          <ng-container matColumnDef="tipoCreacion">
            <th mat-header-cell *matHeaderCellDef>Solicitado por</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.tipoCreacion }}</td>
          </ng-container>

          <ng-container matColumnDef="avance">
            <th mat-header-cell *matHeaderCellDef>Avance Revisión Documentos</th>
            <td mat-cell *matCellDef="let element" class="centre">
              <span *ngIf="element.idEstado==3">{{
                (element.totalDocumentos>0?((element.totalDocumentosRevisados/element.totalDocumentos)*
                100):0).toFixed(0) }} %</span>
              <span *ngIf="element.idEstado!=3 && element.idEstado!=1 && element.idEstado!=2">100 %</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.estado }}</td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <a mat-icon-button color="primary" aria-label="Editar"
                [routerLink]="['/solicitudes', element.idSolicitud, 'revisor', 'validar']">
                <!-- (click)="openDialog(element)" -->
                <mat-icon>search</mat-icon>
              </a>

              <button mat-icon-button color="primary" aria-label="Eliminar"
                *ngIf="element.tieneRegistros ==false && (element.idEstado == 1 || element.idEstado == 2 || element.idEstado == 3) "
                (click)="delete(element)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          <!-- <tr *ngFor="let item of listaUsuarios">
                    <td>{{item.nombre}}</td>
                    <td>{{item.tipo}}</td>
                    <td>{{item.correo}}</td>
                    <td>{{item.estado}}</td>
                </tr> -->
        </table>

        <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" (page)="getPaginatorData($event)"
          [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>


</div>